import React from "react";
import { Badge, Box, Flex, HStack, Text } from "@chakra-ui/react";
import { fmtDateTime } from "../../lib/formatLocale";
import { OPS_ORIGIN_LABEL, adminPreviewText, adminRoomName } from "../../lib/opsChat";

/** 어드민 대화방 목록 한 줄 — 「대화방 관리」 화면과 떠 있는 대화창 공용 */
export default function AdminOpsRoomRow({ r, active = false, onClick }) {
  const name = adminRoomName(r);
  const preview = adminPreviewText(r);
  return (
    <Box as="button" type="button" onClick={onClick} w="100%" textAlign="left" px={3} py={2.5}
      bg={active ? "brand.50" : "white"} borderLeft="3px solid" borderLeftColor={active ? "brand.500" : "transparent"}
      borderBottom="1px solid" borderBottomColor="neutral.100" _hover={{ bg: active ? "brand.50" : "neutral.50" }}>
      <Flex justify="space-between" gap={2}>
        <Text fontSize="14px" fontWeight="700" noOfLines={1}>{name}</Text>
        <Text fontSize="11.5px" color={r.idle_days >= 3 ? "status.error" : "neutral.500"} flexShrink={0}>
          {r.idle_days >= 1 ? `${r.idle_days}일째 답 없음` : fmtDateTime(r.last_message_at)}
        </Text>
      </Flex>
      {r.waiting ? (
        <>
          <HStack spacing={1.5} mt={0.5}>
            <Badge bg="statusWash.warning" color="status.warning" fontSize="10px">연결 대기</Badge>
            {r.origin && OPS_ORIGIN_LABEL[r.origin] && <Text fontSize="11.5px" color="neutral.600">{OPS_ORIGIN_LABEL[r.origin]}</Text>}
            {r.offhours && <Text fontSize="11.5px" color="status.warning">🌙 운영 시간 밖에 들어옴</Text>}
          </HStack>
          {r.topic_label && <Text fontSize="12px" color="neutral.600" noOfLines={1}>{r.topic_label}</Text>}
          {r.first_question && <Text fontSize="12px" color="neutral.700" noOfLines={1}>Q. {r.first_question}</Text>}
        </>
      ) : (
        <Text fontSize="12px" color="neutral.600" noOfLines={1}>
          담당 {r.assignee_name || "없음"} · {fmtDateTime(r.opened_at)} 열림{r.topic_label ? ` · ${r.topic_label}` : ""}
        </Text>
      )}
      <Flex justify="space-between" align="center" gap={2}>
        <Text fontSize="12.5px" color="neutral.600" noOfLines={1}>{preview || " "}</Text>
        {Number(r.unread) > 0 && <Badge bg="status.error" color="white" borderRadius="full" px={1.5} fontSize="10px">{r.unread}</Badge>}
      </Flex>
    </Box>
  );
}
